import axios from 'axios';

// API configuration
export const API_KEY = process.env.REACT_APP_API_KEY || 'test-api-key';
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// Set up axios defaults
axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Authorization'] = `Bearer ${API_KEY}`;